<template>
    <NavView></NavView>
      <SideBar></SideBar>
    <div class="container-fluid" >
     
     
  <div>
  <!-- <h1>{{$route.params.id }}</h1> 
  <h2>{{details.C_name}} my</h2> -->
  <div   >
  
  <nav class="navbar border1">
  <h6 class="hmy pt-2 font1 font-bold1"> <router-link class="decoration" to="/mrentedvehicles/index">Manage Rental VIN </router-link><span class="pfimg1"><i class="fa fa-angle-right" aria-hidden="true"></i></span> {{ gin.SI_issueNum }}  </h6>
  <!-- <p> {{detail.C_name}} ok</p> -->
  <form class="d-flex">
  
  <button class="btn btn-primary ms-1 btn-sm btn-border-radius border-radius0" type="submit">Print VIN</button>
  <button class="btn btn-primary ms-1 btn-sm border-radius0" type="submit">+Refund Payment</button>
  <router-link class=" btn btn-primary ms-1 btn-sm text-light border-radius0" to="/mrentedvehicles/index">Back</router-link> 
  </form>
  </nav>
  
  <!-- <p class="clr2"><b> Details</b> </p> -->
  
  <div class=" mt-2">
  <div class=" container-fluid">
  
  
  
  <div class=" bg-light p-4">
    <table class="table font1  ">
      <tbody>
       
        <tr>
          <td class="width5">Issue No.</td>
          <td class="eddit2">{{gin.SI_issueNum}} </td>
          
        </tr>
        <tr class="">
          <td class="">Issued Date</td>
          <td v-if="!isHidden" class="eddit2"> {{ gin.issues_date}}<br></td>
       
          <td v-else><input  class="me-2" v-model="gin.issues_date"><i class="fa fa-check me-2 pointer1" aria-hidden="true"  v-on:click="save()"  @click="isHidden = false"></i> <i v-on:click="isHidden = false" class="fa fa-times pointer1" aria-hidden="true"></i></td>
          <td class="eddit1 eddit2" v-on:click="isHidden = true"><i class="fa fa-pencil-square-o" aria-hidden="true"></i>
          </td>
        </tr>
        <tr>
          <td >Type</td>
          <td v-if="!isHidden2" class="eddit2">{{gin.SI_type}} </td>
          <td v-else><input class="me-2" v-model="gin.SI_type"><i class="fa fa-check me-2 pointer1" aria-hidden="true"  v-on:click="save()"  @click="isHidden2 = false"></i> <i v-on:click="isHidden2 = false" class="fa fa-times pointer1" aria-hidden="true"></i></td>
          <td class="eddit1 eddit2" v-on:click="isHidden2 = true"><i class="fa fa-pencil-square-o" aria-hidden="true"></i>
          </td>
        </tr>
        <tr>
          <td >Created Date</td>
          <td v-if="!isHidden3" class="eddit2"> {{ gin.SI_created_date}}</td>
          <td v-else><input class="me-2" v-model="gin.SI_created_date"><i class="fa fa-check me-2 pointer1" aria-hidden="true"  v-on:click="save()"  @click="isHidden3 = false"></i> <i v-on:click="isHidden3 = false" class="fa fa-times pointer1" aria-hidden="true"></i></td>
          <td class="eddit1 eddit2" v-on:click="isHidden3 = true"><i class="fa fa-pencil-square-o" aria-hidden="true"></i>
          </td>
        </tr>
        <tr>
          <td >Customer</td>
          <td v-if="!isHidden11" class="eddit2">  {{ gin.id_customer}}</td>
          <td v-else><input class="me-2" v-model="gin.id_customer"><i class="fa fa-check me-2 pointer1" aria-hidden="true"  v-on:click="save()"  @click="isHidden11 = false"></i> <i v-on:click="isHidden11 = false" class="fa fa-times pointer1" aria-hidden="true"></i></td> 
          <td class="eddit1 eddit2" v-on:click="isHidden11 = true"><i class="fa fa-pencil-square-o" aria-hidden="true"></i>
          </td>       
         </tr>
       
        
        <tr>
          <td >Delivery Address</td>
          <td v-if="!isHidden7" class="eddit2">  </td>
          <td v-else><input class="me-2"><i class="fa fa-check me-2 pointer1" aria-hidden="true"  v-on:click="save()"  @click="isHidden7 = false"></i> <i v-on:click="isHidden7 = false" class="fa fa-times pointer1" aria-hidden="true"></i></td>      
          <td class="eddit1 eddit2" v-on:click="isHidden7 = true"><i class="fa fa-pencil-square-o" aria-hidden="true"></i>
          </td>
        
        </tr>
        <tr>
          <td >Sales Person</td>
          <td v-if="!isHidden8" class="eddit2">  {{ gin.SI_sales_person}}</td>
          <td v-else><input class="me-2" v-model="gin.SI_sales_person"><i class="fa fa-check me-2 pointer1" aria-hidden="true"  v-on:click="save()"  @click="isHidden8 = false"></i> <i v-on:click="isHidden8 = false" class="fa fa-times pointer1" aria-hidden="true"></i></td>      
          <td class="eddit1 eddit2" v-on:click="isHidden8 = true"><i class="fa fa-pencil-square-o" aria-hidden="true"></i>
          </td>
        </tr>
        <tr>
            <td >Purpose of Rent</td>
            <td v-if="!isHidden31" class="eddit2">  {{ gin.purpose_of_rent}}</td>
          <td v-else><input class="me-2" v-model="gin.purpose_of_rent"><i class="fa fa-check me-2 pointer1" aria-hidden="true"  v-on:click="save()"  @click="isHidden31 = false"></i> <i v-on:click="isHidden31 = false" class="fa fa-times pointer1" aria-hidden="true"></i></td>      
          <td class="eddit1 eddit2" v-on:click="isHidden31 = true"><i class="fa fa-pencil-square-o" aria-hidden="true"></i>   </td>
        </tr>
        <tr>
            <td >Security Deposit Amount</td>
            <td v-if="!isHidden32" class="eddit2">  {{ gin.security_deposit_amount}}</td>
          <td v-else><input class="me-2" v-model="gin.security_deposit_amount"><i class="fa fa-check me-2 pointer1" aria-hidden="true"  v-on:click="save()"  @click="isHidden32 = false"></i> <i v-on:click="isHidden32 = false" class="fa fa-times pointer1" aria-hidden="true"></i></td>      
          <td class="eddit1 eddit2" v-on:click="isHidden32 = true"><i class="fa fa-pencil-square-o" aria-hidden="true"></i>   </td>  
        </tr>
        <tr>
            <td >Remarks</td>
            <td v-if="!isHidden33" class="eddit2">  {{ gin.SI_remarks}}</td>
            <td v-else><input class="me-2" v-model="gin.SI_remarks"><i class="fa fa-check me-2 pointer1" aria-hidden="true"  v-on:click="save()"  @click="isHidden33 = false"></i> <i v-on:click="isHidden33 = false" class="fa fa-times pointer1" aria-hidden="true"></i></td>      
            <td class="eddit1 eddit2" v-on:click="isHidden33 = true"><i class="fa fa-pencil-square-o" aria-hidden="true"></i>   </td>    
        </tr>
        <tr>
            <td >Status</td> 
            <td v-if="!isHidden34" class="eddit2">  {{ gin.SI_status}}</td>
            <td v-else><input class="me-2" v-model="gin.SI_status"><i class="fa fa-check me-2 pointer1" aria-hidden="true"  v-on:click="save()"  @click="isHidden34 = false"></i> <i v-on:click="isHidden34 = false" class="fa fa-times pointer1" aria-hidden="true"></i></td>      
            <td class="eddit1 eddit2" v-on:click="isHidden34 = true"><i class="fa fa-pencil-square-o" aria-hidden="true"></i>   </td>     
        </tr>
      </tbody>
    </table>
      
        <!-- Tabs navs -->
        
        <!-- Tabs content -->
       
  
  
  
  
  </div>
  <br>

  
  <nav class="navbar navbar-light bg-light">
    <div class="container-fluid font1 font-bold1">
      <span>VIN Details</span>
      <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarToggleExternalContent2" aria-controls="navbarToggleExternalContent" aria-expanded="false" aria-label="Toggle navigation">
        <i class="fa fa-chevron-down" aria-hidden="true"></i>
      </button>
      
    </div>
  </nav>
  <div class="collapse" id="navbarToggleExternalContent2">
    <div class="bg-light p-4">
     
      <!-- Tabs start -->
  
    
    
        
        <!-- Tabs content -->
        <div class="tab-content" id="ex1-content">
        
        <div class="tab-pane fade show active" id="ex1-tabs-11" role="tabpanel" aria-labelledby="ex1-tab-1" >
        <div class=" bg-light ">
        <table class="table font1">
          <tbody>
            <tr>
            
            <th>#</th>
            <th>Brand</th>
            <th>Model</th>
            <th>Registration No.</th>
            <th>Qty</th>
            <th>Start Date</th>
            <th>Return Date</th>
            <th>Extend To</th>
            <th>Actual Start Date</th>
            <th>Actual Return Date</th>
            <th>Rate per Day</th>
            <th>Status</th>
            <th>Extend Remarks</th>
            <th>Fuel Taken</th>
            <th>Start Mileage</th>
            <th>Return Mileage</th>
            <th>Fuel Return</th>
            <th>Actions</th>
         
          </tr>

          <tr v-for="(detail, index) in details" :key="index">
            <td class="eddit2">{{index+1}}</td>
            <td class="eddit2">{{detail.machine}}</td>
            <td class="eddit2">{{detail.model}}</td>
            <td class="eddit2">{{detail.serial_no}}</td>
            <td class="eddit2">{{detail.SD_qty}}</td>
            <td class="eddit2"> {{detail.propose_start_date}} {{detail.propose_start_time}}</td>
            <td class="eddit2">{{detail.propose_return_date}} {{detail.propose_return_time}}</td>
            <td class="eddit2"></td>
            <td class="eddit2">{{detail.from_date}} {{detail.from_time}}</td>
            <td class="eddit2">{{detail.to_date}} {{detail.to_time}}</td>
            <td class="eddit2">{{detail.charge_amount}}</td>
            <td class="eddit2"></td>
            <td class="eddit2">{{detail.extend_remarks}}</td>
            <td class="eddit2">{{detail.fuel_taken}}</td>
            <td class="eddit2">{{detail.start_mileage}}</td>
            <td class="eddit2">{{detail.return_mileage}}</td>
            <td class="eddit2">{{detail.return_fuel}}</td>
            <td class="eddit2"> 
                <button class=" btn btn-primary  btn-sm  text-light me-1 mb-1">Extend </button>
                <button class=" btn btn-primary  btn-sm  text-light mb-1">Service</button>
            </td>
            <td class="eddit1 eddit2" ><i type="button" class="fa fa-pencil-square-o me-2"  data-bs-toggle="modal" data-bs-target="#exampleModal50" v-on:click="product(detail.idStockissuedetails)"></i>  <i class="fa fa-plus me-2" v-on:click="isHidden30 = true" aria-hidden="true"></i><i class="fa fa-minus "   aria-hidden="true"></i> </td>
          
            
        
          
          
          
          </tr>
            <!-- <tr  v-for="detail5 in details5" :key="detail5">
            
              
              <td v-if="!isHidden29" class="eddit2">{{detail5.bank_name}}</td>
              <td v-else><input class="me-1 width4" v-model="bank.bank_name" ></td>      
              <td  v-if="!isHidden29" class="eddit2">{{detail5.branch}}</td>
              <td v-else><input class="me-1 width4" v-model="bank.branch"></td>      
              <td v-if="!isHidden29" class="eddit2">{{detail5.acount_num}}</td>
              <td v-else><input class="me-1 width4" v-model="bank.acount_num"><i class="fa fa-check me-1 pointer1" aria-hidden="true"  v-on:click="update4(detail5.id)"  @click="isHidden29 = false"></i> <i v-on:click="isHidden29 = false" class="fa fa-times pointer1" aria-hidden="true"></i></td>      
              <td class="eddit1 eddit2" v-on:click="isHidden29 = true"><i class="fa fa-pencil-square-o" aria-hidden="true"></i>
              </td>
             -->
            
          </tbody>
        </table>



        <div class="modal fade" id="exampleModal50" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
          <div class="modal-dialog  modal-dialog-centered modal-dialog-scrollable">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">VRN Details Update</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div class="modal-body">
              
                <table class="table font1">
                  <tbody  >

                    <tr>
                      <td>Brand</td>
                      <td><input   v-model="products.machine"   ></td>
                    </tr>
                    <tr>
                      <td>Model</td>
                      <td><input   v-model="products.model"   ></td>
                    </tr>
                     <tr>
                      <td>Registration No.</td>
                      <td><input  v-model="products.serial_no" ></td>
                    </tr>
                    <tr>
                      <td>Qty</td>
                      <td><input  v-model="products.SD_qty" ></td>
                    </tr>
                    <tr>
                      <td>Start Date</td>
                      <td><input  v-model="products.propose_start_date" ></td>
                    </tr>
                    <tr>
                      <td>Start time</td>
                      <td><input  v-model="products.propose_start_time" ></td>
                    </tr>
                    <tr>
                      <td>Return Date</td>
                      <td><input  v-model="products.propose_return_date" ></td>
                    </tr>
                    <tr>
                      <td>Return time</td>
                      <td><input  v-model="products.propose_return_time"  ></td>
                    </tr>
                    <tr>
                      <td>Extend To</td>
                      <td><input   ></td>
                    </tr>
                    <tr>
                      <td>Actual Start Date</td>
                      <td><input   v-model="products.from_date"  ></td>
                    </tr>
                    <tr>
                      <td>Actual Start Time</td>
                      <td><input  v-model="products.from_time"  ></td>
                    </tr>
                    <tr>
                      <td>Actual Return Date</td>
                      <td><input   v-model="products.to_date"  ></td>
                    </tr>
                    <tr>
                      <td>Actual Return Time</td>
                      <td><input  v-model="products.to_time"   ></td>
                    </tr>
                    <tr>
                      <td>Rate per Day</td>
                      <td><input  v-model="products.charge_amount"   ></td>
                    </tr>
                    <tr>
                      <td>Status</td>
                      <td><input  ></td>
                    </tr>
                    <tr>
                      <td>Extend Remarks</td>
                      <td><input v-model="products.extend_remarks"  ></td>
                    </tr>
                    <tr>
                      <td>Fuel Taken</td>
                      <td><input v-model="products.fuel_taken"  ></td>
                    </tr>
                    <tr>
                      <td>Start Mileage</td>
                      <td><input v-model="products.start_mileage"  ></td>
                    </tr>
                    <tr>
                      <td>Return Mileage</td>
                      <td><input v-model="products.return_mileage"  ></td>
                    </tr>
                    <tr>
                      <td>Fuel Return</td>
                      <td><input  v-model="products.return_fuel"   ></td>
                    </tr>

                </tbody>
              </table>




              </div>
              <div class="modal-footer">
                
                <button type="button" v-on:click="detailUpdate(products.idStockissuedetails)" class="btn btn-primary">Update</button>
              </div>
            </div>
          </div>
        </div>




        </div>
      </div>
        </div>
  
  
  
  
  
    
    </div>
  </div>
<br>
  <nav class="navbar navbar-light bg-light">
    <div class="container-fluid font1 font-bold1">
      <span>VRN Details</span>
      <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarToggleExternalContent21" aria-controls="navbarToggleExternalContent" aria-expanded="false" aria-label="Toggle navigation">
        <i class="fa fa-chevron-down" aria-hidden="true"></i>
      </button>
      
    </div>
  </nav>
  <div class="collapse" id="navbarToggleExternalContent21">
    <div class="bg-light p-4">
     
      <!-- Tabs start -->
  
    
    
        
        <!-- Tabs content -->
        <div class="tab-content" id="ex1-content">
        
        <div class="tab-pane fade show active" id="ex1-tabs-11" role="tabpanel" aria-labelledby="ex1-tab-1" >
        <div class=" bg-light ">
        <table class="table font1">
          <tbody>
            <tr>
            
            <th>#</th>
            <th>VRN No</th>
            <th>Received Date</th>
            <th>Brand</th>
            <th>Model</th>
            <th>Reg. No.</th>
            <th>Created Date</th>
            <th>Status</th>
           
         
          </tr>

          <tr v-for="(detail, index) in details" :key="index">
            <td class="eddit2">{{index+1}}</td>
            <td class="eddit2"></td>
            <td class="eddit2">{{detail.from_date}}</td>
            <td class="eddit2">{{detail.machine}}</td>
            <td class="eddit2">{{detail.model}}</td>
            <td class="eddit2">{{detail.serial_no}}</td>
            <td class="eddit2">{{detail.from_date}} {{detail.from_time}}</td>
            <td class="eddit2">(status)</td>
           <td class="eddit1 eddit2" ><i type="button" class="fa fa-pencil-square-o me-2"  data-bs-toggle="modal" data-bs-target="#exampleModal501" v-on:click="product(detail.idStockissuedetails)"></i>  <i class="fa fa-plus me-2" v-on:click="isHidden30 = true" aria-hidden="true"></i><i class="fa fa-minus "   aria-hidden="true"></i> </td>

       


          </tr>
            <!-- <tr  v-for="detail5 in details5" :key="detail5">
            
              
              <td v-if="!isHidden29" class="eddit2">{{detail5.bank_name}}</td>
              <td v-else><input class="me-1 width4" v-model="bank.bank_name" ></td>      
              <td  v-if="!isHidden29" class="eddit2">{{detail5.branch}}</td>
              <td v-else><input class="me-1 width4" v-model="bank.branch"></td>      
              <td v-if="!isHidden29" class="eddit2">{{detail5.acount_num}}</td>
              <td v-else><input class="me-1 width4" v-model="bank.acount_num"><i class="fa fa-check me-1 pointer1" aria-hidden="true"  v-on:click="update4(detail5.id)"  @click="isHidden29 = false"></i> <i v-on:click="isHidden29 = false" class="fa fa-times pointer1" aria-hidden="true"></i></td>      
              <td class="eddit1 eddit2" v-on:click="isHidden29 = true"><i class="fa fa-pencil-square-o" aria-hidden="true"></i>
              </td>
             -->
            
          </tbody>
        </table>


          
        <div class="modal fade" id="exampleModal501" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
          <div class="modal-dialog  modal-dialog-centered modal-dialog-scrollable">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">VIN Details Update</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div class="modal-body">
              
                <table class="table font1">
                  <tbody >

                    <tr>
                      <td>Received Date</td>
                      <td><input   v-model="products.from_date"   ></td>
                    </tr>
                    <tr>
                      <td>Brand</td>
                      <td><input   v-model="products.machine"   ></td>
                    </tr>
                     <tr>
                      <td>Model</td>
                      <td><input  v-model="products.model" ></td>
                    </tr>
                    <tr>
                      <td>Reg. No.</td>
                      <td><input  v-model="products.serial_no" ></td>
                    </tr>
                    <tr>
                      <td>Created Date</td>
                      <td><input  v-model="products.from_date" ></td>
                    </tr>
                    <tr>
                      <td>Created Time</td>
                      <td><input  v-model="products.from_time" ></td>
                    </tr>
                    

                </tbody>
              </table>




              </div>
              <div class="modal-footer">
                
                <button type="button" v-on:click="detailUpdate(products.idStockissuedetails)" class="btn btn-primary">Update</button>
              </div>
            </div>
          </div>
        </div>
          






        </div>
      </div>
        </div>
  
  
  
  
  
    
    </div>
  </div>
<br>


<nav class="navbar navbar-light bg-light">
    <div class="container-fluid font1 font-bold1">
      <span>Transactions Related To Rental</span>
      <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarToggleExternalContent22" aria-controls="navbarToggleExternalContent" aria-expanded="false" aria-label="Toggle navigation">
        <i class="fa fa-chevron-down" aria-hidden="true"></i>
      </button>
      
    </div>
  </nav>
  <div class="collapse" id="navbarToggleExternalContent22">
    <div class="bg-light p-4">
     
      <!-- Tabs start -->
  
    
    
        
        <!-- Tabs content -->
        <div class="tab-content" id="ex1-content">
        
        <div class="tab-pane fade show active" id="ex1-tabs-11" role="tabpanel" aria-labelledby="ex1-tab-1" >
        <div class=" bg-light ">
        <table class="table font1">
          <tbody>
            <tr>
            
            <th>#</th>
            <th>Invoice / Receipt #</th>
            <th>Transaction Date</th>
            <th>Description</th>
            <th>Invoice Amount S($)</th>
            <th>Paid Amount S($)</th>
            <th>Balance S($)</th>
           
           
         
          </tr>

          <tr>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            
           
          </tr>
            <!-- <tr  v-for="detail5 in details5" :key="detail5">
            
              
              <td v-if="!isHidden29" class="eddit2">{{detail5.bank_name}}</td>
              <td v-else><input class="me-1 width4" v-model="bank.bank_name" ></td>      
              <td  v-if="!isHidden29" class="eddit2">{{detail5.branch}}</td>
              <td v-else><input class="me-1 width4" v-model="bank.branch"></td>      
              <td v-if="!isHidden29" class="eddit2">{{detail5.acount_num}}</td>
              <td v-else><input class="me-1 width4" v-model="bank.acount_num"><i class="fa fa-check me-1 pointer1" aria-hidden="true"  v-on:click="update4(detail5.id)"  @click="isHidden29 = false"></i> <i v-on:click="isHidden29 = false" class="fa fa-times pointer1" aria-hidden="true"></i></td>      
              <td class="eddit1 eddit2" v-on:click="isHidden29 = true"><i class="fa fa-pencil-square-o" aria-hidden="true"></i>
              </td>
             -->
            
          </tbody>
        </table>
        </div>
      </div>
        </div>
    
    </div>
  </div>
  <br>



  <nav class="navbar navbar-light bg-light">
    <div class="container-fluid font1 font-bold1">
      <span>Additional Charges for this Rental</span>
      <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarToggleExternalContent23" aria-controls="navbarToggleExternalContent" aria-expanded="false" aria-label="Toggle navigation">
        <i class="fa fa-chevron-down" aria-hidden="true"></i>
      </button>
      
    </div>
  </nav>
  <div class="collapse" id="navbarToggleExternalContent23">
    <div class="bg-light p-4">
     
      <!-- Tabs start -->
  
    
    
        
        <!-- Tabs content -->
        <div class="tab-content" id="ex1-content">
        
        <div class="tab-pane fade show active" id="ex1-tabs-11" role="tabpanel" aria-labelledby="ex1-tab-1" >
        <div class=" bg-light ">
        <table class="table font1">
          <tbody>
            <tr>
            
            <th>Charge Name</th>
            <th>Charge Description</th>
            <th>Amount</th>
           
           
         
          </tr>

          <tr>
            <td></td>
            <td></td>
            <td></td>
           
            
           
          </tr>
            <!-- <tr  v-for="detail5 in details5" :key="detail5">
            
              
              <td v-if="!isHidden29" class="eddit2">{{detail5.bank_name}}</td>
              <td v-else><input class="me-1 width4" v-model="bank.bank_name" ></td>      
              <td  v-if="!isHidden29" class="eddit2">{{detail5.branch}}</td>
              <td v-else><input class="me-1 width4" v-model="bank.branch"></td>      
              <td v-if="!isHidden29" class="eddit2">{{detail5.acount_num}}</td>
              <td v-else><input class="me-1 width4" v-model="bank.acount_num"><i class="fa fa-check me-1 pointer1" aria-hidden="true"  v-on:click="update4(detail5.id)"  @click="isHidden29 = false"></i> <i v-on:click="isHidden29 = false" class="fa fa-times pointer1" aria-hidden="true"></i></td>      
              <td class="eddit1 eddit2" v-on:click="isHidden29 = true"><i class="fa fa-pencil-square-o" aria-hidden="true"></i>
              </td>
             -->
            
          </tbody>
        </table>
        </div>
      </div>
    </div>
    
    </div>
  </div><br>



  
  <nav class="navbar navbar-light bg-light">
    <div class="container-fluid font1 font-bold1">
      <span>Payments</span>
      <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarToggleExternalContent24" aria-controls="navbarToggleExternalContent" aria-expanded="false" aria-label="Toggle navigation">
        <i class="fa fa-chevron-down" aria-hidden="true"></i>
      </button>
      
    </div>
  </nav>
  <div class="collapse" id="navbarToggleExternalContent24">
    <div class="bg-light p-4">
     
      <!-- Tabs start -->
  
    
    
        
        <!-- Tabs content -->
        <div class="tab-content" id="ex1-content">
        
        <div class="tab-pane fade show active" id="ex1-tabs-11" role="tabpanel" aria-labelledby="ex1-tab-1" >
        <div class=" bg-light ">
        <div class="card font1 ">
        <div class="card-body font1">


            <div class="row ">
                    <CCol md="3">
                        <CFormLabel  for="inputState">Payment Mode</CFormLabel> 
                        <CFormSelect class=" "  name="name3" id="notificationPreference"  rules="required" >
                                
                            <option class="font1">Select Payment mode</option>
                           
                            <option class="font1">Cash</option>
                            <option class="font1">Cheque</option>
                            <option class="font1">Giro</option>
                          
                        </CFormSelect>
                        
                         
                     </CCol>

                    <CCol md="3">
                        <CFormLabel  for="inputState">Receipt Date</CFormLabel> 
                        <Field name="Issue_date" type="date"  class="form-control" 
                        />
                        
                        
                    </CCol>
                    <CCol md="3">
                        <CFormLabel  for="inputState">Paid Amount</CFormLabel> 
                        <Field name="Issue_date" type="text"  class="form-control" 
                        />
                        
                        
                    </CCol>
                    <CCol md="3">
                        <CFormLabel  for="inputState">Bank Name</CFormLabel> 
                        <CFormSelect class=" "  name="name3" id="notificationPreference"  rules="required" >
                                
                            <option class="font1">Select Bank Account</option>
                           
                            <option class="font1">Cash</option>
                            <option class="font1">Cheque</option>
                            <option class="font1">Giro</option>
                          
                        </CFormSelect>
                        
                         
                     </CCol>
            </div><br>
            <div class="row">
                <CCol md="3">
                    <CFormLabel  for="inputState">Bank Slip Image</CFormLabel> 
                    
                    <input type="file" class="form-control" id="inputGroupFile02">
                    
                    
                </CCol>
            </div>

            <CCol class="right1 mt-4">
                       
                    
                <div class="d-grid gap-2 d-md-flex justify-content-md-end mb-2">
                
                    <button type="button" class="btn btn-primary btn-sm ps-3 pe-3">Add</button>
                    
                </div>
            </CCol>
 
        </div>
        </div><br>
        <table class="table font1">
            <tbody>
              <tr>
              
              <th>#</th>
              <th>Customer</th>
              <th>Paid Amount</th>
              <th>Payment Type</th>
              <th>Receipt Number</th>
              <th>Receipt Date</th>
             
             
           
            </tr>
  
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
             
              
             
            </tr>
              <!-- <tr  v-for="detail5 in details5" :key="detail5">
              
                
                <td v-if="!isHidden29" class="eddit2">{{detail5.bank_name}}</td>
                <td v-else><input class="me-1 width4" v-model="bank.bank_name" ></td>      
                <td  v-if="!isHidden29" class="eddit2">{{detail5.branch}}</td>
                <td v-else><input class="me-1 width4" v-model="bank.branch"></td>      
                <td v-if="!isHidden29" class="eddit2">{{detail5.acount_num}}</td>
                <td v-else><input class="me-1 width4" v-model="bank.acount_num"><i class="fa fa-check me-1 pointer1" aria-hidden="true"  v-on:click="update4(detail5.id)"  @click="isHidden29 = false"></i> <i v-on:click="isHidden29 = false" class="fa fa-times pointer1" aria-hidden="true"></i></td>      
                <td class="eddit1 eddit2" v-on:click="isHidden29 = true"><i class="fa fa-pencil-square-o" aria-hidden="true"></i>
                </td>
               -->
              
            </tbody>
          </table>



        </div>
      </div>
    </div>
    
    </div>
  </div><br>

  <nav class="navbar navbar-light bg-light">
    <div class="container-fluid font1 font-bold1">
      <span>Audit Trail</span>
      <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarToggleExternalContent25" aria-controls="navbarToggleExternalContent" aria-expanded="false" aria-label="Toggle navigation">
        <i class="fa fa-chevron-down" aria-hidden="true"></i>
      </button>
      
    </div>
  </nav>
  <div class="collapse" id="navbarToggleExternalContent25">
    <div class="bg-light p-4">
     
      <!-- Tabs start -->
  
    
    
        
        <!-- Tabs content -->
        <div class="tab-content" id="ex1-content">
        
        <div class="tab-pane fade show active" id="ex1-tabs-11" role="tabpanel" aria-labelledby="ex1-tab-1" >
        <div class=" bg-light ">
        <table class="table font1">
          <tbody>
            <tr>
            
            <th>#</th>
            <th>Comment</th>
            <th>Job Type</th>
            <th>Created Date</th>
            <th>Added By</th>
            <th>Field Name</th>
            <th>Action</th>
            <th>Previous Value</th>
           
           
         
          </tr>

          <tr>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
           
            
           
          </tr>
            <!-- <tr  v-for="detail5 in details5" :key="detail5">
            
              
              <td v-if="!isHidden29" class="eddit2">{{detail5.bank_name}}</td>
              <td v-else><input class="me-1 width4" v-model="bank.bank_name" ></td>      
              <td  v-if="!isHidden29" class="eddit2">{{detail5.branch}}</td>
              <td v-else><input class="me-1 width4" v-model="bank.branch"></td>      
              <td v-if="!isHidden29" class="eddit2">{{detail5.acount_num}}</td>
              <td v-else><input class="me-1 width4" v-model="bank.acount_num"><i class="fa fa-check me-1 pointer1" aria-hidden="true"  v-on:click="update4(detail5.id)"  @click="isHidden29 = false"></i> <i v-on:click="isHidden29 = false" class="fa fa-times pointer1" aria-hidden="true"></i></td>      
              <td class="eddit1 eddit2" v-on:click="isHidden29 = true"><i class="fa fa-pencil-square-o" aria-hidden="true"></i>
              </td>
             -->
            
          </tbody>
        </table>
        </div>
      </div>
    </div>
    
    </div>
  </div>









  
 
  <br>
  <nav class="navbar navbar-light bg-light">
    <div class="container-fluid font1 font-bold1">
      <span>CRM Notes</span>
      <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarToggleExternalContent7" aria-controls="navbarToggleExternalContent" aria-expanded="false" aria-label="Toggle navigation">
        <i class="fa fa-chevron-down" aria-hidden="true"></i>
      </button>
      
    </div>
  </nav>
  <div class="collapse" id="navbarToggleExternalContent7">
    <div class="bg-light p-4">
      <table class="table font1">
        <tbody>
          <tr>
            <td >#</td>
            <td >Comment </td>
            <td >Job Type </td>
            <td >Created Date </td>
            <td >Created By </td>
            <td >Follow up Date </td>
            <td >Follow up by </td>
      
              
          </tr>
        </tbody>
      </table>
    
    </div>
  </div>
  
  
  <br>

  <nav class="navbar navbar-light bg-light">
    <div class="container-fluid font1 font-bold1">
      <span>Add CRM Notes</span>
      <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarToggleExternalContent15" aria-controls="navbarToggleExternalContent" aria-expanded="false" aria-label="Toggle navigation">
        <i class="fa fa-chevron-down" aria-hidden="true"></i>
      </button>
      
    </div>
  </nav>
  <div class="collapse" id="navbarToggleExternalContent15">
    <div class="bg-light p-4">
    <div class="card font1 ">
    <div class="card-body font1">
    
        <div class="row ">
            <CCol md="3">
                <CFormLabel  for="inputState">Job Type</CFormLabel> 
                <CFormSelect class=" "  name="name3" id="notificationPreference"  rules="required" >
                        
                    <option class="font1">Select Job Type</option>
                   
                    <option class="font1">Vehicle Sales</option>
                    <option class="font1">Spare Parts Sales</option>
                   >
                  
                </CFormSelect>
                
                 
             </CCol>

            <CCol md="3">
                <CFormLabel  for="inputState">Follow up Date</CFormLabel> 
                <Field name="Issue_date" type="date"  class="form-control" 
                />
                
                
            </CCol>
            <CCol md="3">
                <CFormLabel  for="inputState">Follow Up By</CFormLabel> 
                <Field name="Issue_date" type="text"  class="form-control" 
                />
                
                
            </CCol>
            <CCol md="3">
                <CFormLabel  for="inputState">Comments</CFormLabel> 
                <textarea   class="form-control"  rows="4"></textarea> 
                
                 
             </CCol>
        </div>

        <CCol class="right1 mt-4">
                       
                    
            <div class="d-grid gap-2 d-md-flex justify-content-md-end mb-2">
            
                <button type="button" class="btn btn-primary btn-sm ps-3 pe-3">Save</button>
                
            </div>
        </CCol>

    </div>
    </div>


    </div>
  </div>
  
  
  
  
  </div>
  
  
  <!-- Tabs content -->
  
  
   
   
  
  
   
  
          
  
  </div>
  
    </div> 
      <br>
      <div class="d-grid gap-2 d-md-flex justify-content-md-end mb-5">
                        
        <!-- <Button   class=" btn btn-success" type=""> Conform</Button>
        <button class="btn1 btn btn-danger ">Back</button> -->
       
    </div>
  
  
  </div>
  

  
  
    </div>
  </template>
  
  <script>
    import {  CCol, CFormLabel, CFormSelect  } from '@coreui/vue';
    import {  Field  } from 'vee-validate';
   import authService from '@/auth.service';
   import axios from 'axios';
  
  import NavView from '../../components/NavView.vue'
      import SideBar from '../../components/SideBar.vue'
  
  
  export default {
  
    mounted(){
      this.loadData2(this.$route.query.data);
    },
  
  
  //   mounted(){
  //   if(this.$route.params.id){
  //       localStorage.setItem('token',this.$route.params.id);
  //   }
   
  // this.loadData2(localStorage.getItem('token'));
  // },
  
  data(){
    return{
      
      access_token:authService.isLoggedIn(),
      details:'',
      detail1:{

      },
      detail2:{

      },

     
      
      isHidden: false,
      isHidden1: false,
      isHidden2: false,
      isHidden3: false,
      isHidden4: false,
      isHidden5: false,
      isHidden6: false,
      isHidden7: false,
      isHidden8: false,
      isHidden9: false,
      isHidden10: false,
      isHidden11: false,
      isHidden12: false,
      isHidden13: false,
      isHidden14: false,
      isHidden15: false,
      isHidden16: false,
      isHidden17: false,
      isHidden18: false,
      isHidden19: false,
      isHidden20: false,
      isHidden21: false,
      isHidden22: false,
      isHidden23: false,
      isHidden24: false,
      isHidden25: false,
      isHidden26: false,
      isHidden27: false,
      isHidden28: false,
      isHidden29: false,
      isHidden30: false,
      isHidden31: false,
      isHidden32: false,
      isHidden33: false,
      isHidden34: false,
  
     
     
      products:{
        
      },
      
        
      
    
      
      'gin': {
        'idCustomer':this.$route.query.data,
        'C_name':'',
        'SI_issueNum':'',
        'issues_date':'',
        'SI_type':'',
        'SI_created_date':'',
        'SI_sales_person':'',
        'purpose_of_rent':'',
        'security_deposit_amount':'',
        'SI_remarks':'',
        'SI_status':'',
        
      
        
      },
      'idCustomer':this.$route.query.data,
    }
  },
  
  components:{
    NavView,SideBar,CCol, CFormLabel, Field, CFormSelect
  },
  
  
  
  methods:{
  
    
  
    myFunction() {
    var x = document.getElementById("myDIV");
    if (x.style.display === "none") {
      x.style.display = "block";
    } else {
      x.style.display = "none";
    }
  },
  
   
  
  
       loadData2(userid) {
     
     console.log(userid); 
     axios.get('/web/api/istockissue/view?id='+userid ,{
      headers:{
            'Authorization':'Bearer '+this.access_token,
            'Content-type': 'application/json',
           
          }
         }).then(
        response => {
          console.log(response);
         
  
        this.details = response.data.details;
          
        
           // this.details3 = response.data.address;
          
            this.gin = response.data.item_list;
           // this.details4 = response.data.contacts;
           // this.details5 = response.data.bankdet;
           // this.contact_length = response.data.contacts.length;
          
        
    //         console.log('amila thilanka');
    //   console.log(this.contact_length);
    //   for(let i = 1; i <= this.contact_length; i++){
    //   this.contact.push({},);
    //   }
        //this.$refs.table.innerHTML = response.data.success;
          // window.location.reload();
          
        }
       
       )
      
      
       
   
  
    } ,
  
   
  
     save(){
      console.log(this.$route.query.data);
      console.log(this.gin);
      
      axios.post('/web/api/istockissue/edit?id='+this.$route.query.data, {gin:this.gin},{
      headers:{
            'Authorization':'Bearer '+this.access_token,
            'Content-type': 'application/json',
           
          }
         }).then(
          response => {
            console.log(response);
          }
         )
  
    },

    product(id){
      
      console.log(id);
      
      axios.get('/web/api/istockissuedetails/edit?id='+id, {
      headers:{
            'Authorization':'Bearer '+this.access_token,
            'Content-type': 'application/json',
           
          }
         }).then(
          response => {
            console.log(response);
            this.products = response.data.product;

          }
         )
  
    },


    detailUpdate(id){
      console.log(id)
      console.log(this.products);
      axios.post('/web/api/istockissuedetails/edit?id='+id, {ginddet:this.products},{
      headers:{
            'Authorization':'Bearer '+this.access_token,
            'Content-type': 'application/json',
           
          }
         }).then(
          response => {
            console.log(response);
            window.location.reload();
          }
         )
  
    },
   
   
   
   
  
  
  
  
  
  }
  }
  
  </script>
  
  <style scoped>
    .width1{
        width: 15%;
    }
    .width5{
        width: 25%;
    }
    .width6{
        width: 100%;
    }
  
    .btn1 {
        padding-left: 18px;
        padding-right: 18px;
    }
    
    td{
     padding: 2px;
     
  
    }
    .font1{
      font-size: 13px !important;
   
    }
    .font-bold1{
      font-weight: bold;
    }
    .clr2 {
        background-color: #AED8F2;
        padding: 2px;
        border-radius: 3px
    }
    .decoration{
      text-decoration: none;
      color:#A5A5A3  ;
    }
  
    .hmy{
      color: black;
    }
  
    .border1{
      border-bottom: #E9E9E3 solid 2px;
      border-top: #E9E9E3 solid 2px;
      padding: 2px;
    }
    .eddit1{
      
      display: none;
    }
    .eddit1:hover{
      cursor: pointer;
    }
    
    .eddit2:hover  + .eddit1, .eddit1:hover{
      display: inline-table !important;
      margin-top: 5px;
    }
    .hiden2{
      display: none;
    }
    .nav-link{
      color: black !important;
    }
    .nav-link:focus{
      color: blue !important;
    }
    .nav-link.active{
      color: blue !important;
    }
    .border-radius0{
      border-radius:0px !important ;
    }
    .pointer1:hover{
      cursor: pointer;
    }
    .width2{
      width: 12%;
    }
    .width3{
      width: 25% !important;
    }
    .width4{
      width: 100px;
    }
   
    
  </style>